<template>
    <div>
      <!-- <b-button v-b-modal.modal-filter-spam class="ml-2 filter-button">
        <i class="fas fa-solid fa-filter" />
      </b-button>
      <b-modal id="modal-filter-spam" size="xl" hide-footer :title="$t('textFiltro')">
    -->
      <!-- <b-modal size="xl" hide-footer :title="$t('textFiltro')"> -->
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
            <div class="form-group">
              <label for> {{ $t("sectionConversas.conversasPessoa") }}</label>
              <input v-model="filtro.pessoa" type="text" class="form-control" />
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-3 col-xl-2">
            <div class="form-group">
              <label for>{{ $t("sectionConversas.conversasTelefone") }}</label>
              <input v-model="filtro.numero" type="number" class="form-control" />
              <!-- <label for>{{ $t("sectionConversas.conversasTelefone") }}/{{ $t("sectionAtendimento.atendimentoUsuario") }}</label>
              <input v-model="filtro.numero" type="text" class="form-control" /> -->
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-5 col-xl-3">
            <div class="form-group">
              <label for>{{ $t("sectionConversas.conversasAtendente") }}</label>
              <v-select
                v-model="filtro.atendentes"
                :placeholder="$t('textSelecione')"
                :options="atendenteOptions"
                multiple
                @search:focus="ObterAtendenteSelect2"
              >
                <template slot="no-options">
                  {{ $t("textAguardeNenhumResultado") }}
                </template>
              </v-select>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-3 col-lg-2 col-xl-2"
            :title="$t('textAguardeNenhumResultado')"
          >
            <div class="form-group">
              <label for>{{
                $t("sectionConversas.conversasAtendenteSim")
              }}</label>
              <b-form-checkbox
                v-model="filtro.isSemAtendente"
                name="check-button"
                switch
                @click.native="onSelectedSemAtendente"
              >
                {{ $t("textYes") }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
           <!-- <div class="col-sm-12 col-md-2 col-lg-3 col-xl-2"> 
            <div class="form-group">
              <label for>{{ $t("sectionConversas.conversasOrdenar") }}</label>
              <select v-model="filtro.ordem" class="form-control" disabled required>
                <option selected value="1">{{ $t("textNovos") }}</option>
                <option value="2">{{ $t("textAntigos") }}</option>
              </select>
            </div> 
            <div style="white-space: nowrap;">
              <span style="color: #f74444; font-size: 0.8rem;">{{ $t("sectionParametro.parametroInformativo") }}</span>
            </div> 
           </div>  -->
           
           <!-- filtro por tipo -->
           <!-- <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
          <div class="form-group">

            <label for>{{
              $t("sectionAtendimento.atendimentoTipo")
            }}</label>
                  <select v-model="filtro.tipo" class="form-control">
                    <option selected :value=null>
                      {{ $t("sectionAtendimento.atendimentoSelecione") }}
                    </option>
                    <option value=0>WhatsApp</option>
                     <option value="2">Facebook</option> 
                    <option value=1>Instagram</option>
                  </select>
          </div>
        </div> -->

          <div class="col-sm-12 col-md-4 col-lg-5 col-xl-3">
            <div class="form-group">
              <label for>{{ $t("sectionConversas.conversasEtapas") }}</label>
              <v-select
              v-model="filtro.etapas"
                class="style-chooser"
                :placeholder="$t('textSelecione')"
                :options="etapaOptions"
                multiple
                @search:focus="ObterEtapaSelect2"
              >
                <template slot="no-options">
                  {{ $t("textAguardeNenhumResultado") }}
                </template>
              </v-select>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-3 col-lg-2 col-xl-2"
            :title="$t('sectionConversas.somenteContatoMensagensNaoLidas')"
          >
            <div class="form-group">
              <label for>{{ $t("sectionConversas.conversasLida") }}</label>
              <b-form-checkbox v-model="filtro.isNova" name="check-button" switch>
                {{ $t("textYes") }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col">
            <label  for>{{
              $t("sectionConversas.conversasPeriodoMensagens")
            }}</label>
          </div>
        </div> -->
        <!-- <div class="row">
        <div class="col-3">
          <div class="form-group">
            <label for>{{ $t("sectionConversas.conversasDataInicial") }}</label>
            <input
              v-model="filtro.periodoConversaInicial"
              class="form-control"
              type="date"
            />
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for>{{ $t("sectionConversas.conversasDataFinal") }}</label>
            <input
              v-model="filtro.periodoConversaFinal"
              class="form-control"
              type="date"
            />
          </div>
        </div>
      </div> -->
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group style_button">
              <button
                class="btn btn-primary mr-2"
                type="button"
                @click="Filtrar()"
              >
                {{ $t("btFiltrar") }}
              </button>
              <button class="btn btn-secondary" type="button" @click="Limpar()">
                {{ $t("btLimpar") }}
              </button>
            </div>
          </div>
        </div>
      <!-- </b-modal> -->
    </div>
  </template>
  <script>
  export default {
    name: "FilterContactSpam",
    props: ["dadosFiltradosCompanyPhone"],
    data() {
      return {
        loading: false,
      atendenteOptions: [],
      etapaOptions: [],
      numero: 1,
      collapseFiltro: true,
      telefoneInterval: "",
      telefoneDadoGeral: {
        marcaTelefone: "",
        percentualBateria: 0,
        comInternet: false,
        ligadoEnergia: false,
        DataAlteracao: null
      },
      filtro: this.dadosFiltradosCompanyPhone
      
    }
  },
    methods: {
      Filtrar() {
        this.filtro.telefone = this.dadosFiltradosCompanyPhone.telefone
        this.filtro.contaId = this.$store.getters.getAutenticacao.contaSelecionadaId

        if (this.checkInitialValuesFilter()) {
          this.clearFilter()
        }
  
        this.$emit("filter-button", this.numero, this.filtro)
        this.$bvModal.hide("modal-filter-spam")
      },
      checkInitialValuesFilter() {
        return (
          (!this.filtro.numero || this.filtro.numero == "") &&
          (!this.filtro.pessoa || this.filtro.pessoa == "") &&
          (!this.filtro.atendentes || this.filtro.atendentes.length == 0) &&
          (!this.filtro.etapas || this.filtro.etapas.length == 0) &&
          !this.filtro.isNova &&
          this.filtro.ordem == 2 &&
          (!this.filtro.periodoConversaInicial ||
            this.filtro.periodoConversaInicial == "") &&
          (!this.filtro.periodoConversaFinal ||
            this.filtro.periodoConversaFinal == "") &&
          !this.filtro.isSemAtendente
        )
      },
      clearFilter() {
        this.filtro.numero = ""
        this.filtro.pessoa = ""
        this.filtro.atendentes = null
        this.filtro.etapas = null
        this.filtro.isNova = false
        //this.filtro.tipo = null
        this.filtro.telefone = this.dadosFiltradosCompanyPhone.telefone
        // this.filtro.isPendente = false;
        this.filtro.ordem = 2
        this.filtro.periodoConversaInicial = ""
        this.filtro.periodoConversaFinal = ""
        this.filtro.isSemAtendente = false
      },
      Limpar() {
        this.filtro.numero = ""
        this.filtro.pessoa = ""
        this.filtro.atendentes = null
       // this.filtro.tipo = null
        this.filtro.etapas = null
        this.filtro.isNova = false
        this.filtro.telefone = this.dadosFiltradosCompanyPhone.telefone
        // this.filtro.isPendente = false;
        this.filtro.ordem = 2
        this.filtro.periodoConversaInicial = ""
        this.filtro.periodoConversaFinal = ""
        this.filtro.isSemAtendente = false
        this.Filtrar()
      },
      ObterEtapaSelect2() {
        if (this.etapaOptions.length > 0) return
  
        // this.loading = true;
        this.$http({
          url: "/etapa/obter-select2",
          method: "GET"
        })
          .then((response) => {
            // this.loading = false;
            this.etapaOptions = response.data
          })
          .catch((erro) => {
            // this.loading = false;
            this.$notify({
              data: erro.response.data.erros,
              type: "warn",
              duration: 10000
            })
          })
      },
      ObterAtendenteSelect2() {
        if (this.atendenteOptions.length > 0) return
  
        // this.loading = true;
        this.$http({
          url:
            "/usuario/obter-select2-atendente/" +
            this.$store.getters.getAutenticacao.contaSelecionadaId,
          method: "GET"
        })
          .then((response) => {
            // this.loading = false;
            this.atendenteOptions = response.data
          })
          .catch((erro) => {
            // this.loading = false;
            this.$notify({
              data: erro.response.data.erros,
              type: "warn",
              duration: 10000
            })
          })
      },
      ObterTelefoneDadoGeral(telefone) {
        if (!telefone || !telefone.id) return
        this.$http({
          url:
            "telefone/obter-dado-geral/" +
            telefone.id +
            "/" +
            this.$store.getters.getAutenticacao.contaSelecionadaId,
          method: "GET"
        })
          .then((resposta) => {
            this.telefoneDadoGeral = resposta.data
            this.MostrarAlertasDadoGeral(resposta.data)
            this.AtivarTelefoneInterval()
          })
          .catch((erro) => {
            this.$notify({
              data: erro.response.data.erros,
              type: "warn",
              duration: 10000
            })
          })
      },
      AtivarTelefoneInterval() {
        if (this.telefoneInterval) return
        let vm = this
        this.telefoneInterval = setInterval(function () {
          vm.ObterTelefoneDadoGeral(vm.filtro.telefone)
        }, 1800000)
      },
      MostrarAlertasDadoGeral() {
        let array = []
  
        if (array.length > 0)
          this.$notify({
            data: array,
            type: "warn",
            duration: 10000
          })
      },
      onSelectedSemAtendente() {
        this.filtro.atendentes = null
      }
    }
  }
  </script>
  
  <style scoped>
  .style-chooser .vs__dropdown-menu {
    max-height: 200px;
  }
  
  .style_button {
    margin-top: 0px !important;
    margin-bottom: 0.5rem !important;
  }
  </style>
  